import { render, staticRenderFns } from "./UpdateEmployeePlus.vue?vue&type=template&id=416f20c8&scoped=true"
import script from "./UpdateEmployeePlus.vue?vue&type=script&lang=js"
export * from "./UpdateEmployeePlus.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmployeePlus.vue?vue&type=style&index=0&id=416f20c8&lang=css"
import style1 from "./UpdateEmployeePlus.vue?vue&type=style&index=1&id=416f20c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f20c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416f20c8')) {
      api.createRecord('416f20c8', component.options)
    } else {
      api.reload('416f20c8', component.options)
    }
    module.hot.accept("./UpdateEmployeePlus.vue?vue&type=template&id=416f20c8&scoped=true", function () {
      api.rerender('416f20c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/UpdateEmployeePlus.vue"
export default component.exports